import {ChangeDetectionStrategy,Component,inject} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {NgOptimizedImage} from '@angular/common';
import {Meta,Title} from '@angular/platform-browser';
import {GalleryModule} from 'ng-gallery';

import {AppService} from '../app.service';

/**
 * ng-gallery v13 dropped the imperative `ImageItem`/`GalleryItem` classes for a declarative API,
 * so items are now plain objects rendered by a `galleryItemDef` template.
 */
interface GalleryPicture{src:string;thumb:string;alt:string}

@Component({
	selector:'app-index',
	imports:[MatCardModule,MatIconModule,NgOptimizedImage,GalleryModule],
	templateUrl:'./index.html',
	styleUrl:'./index.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class IndexComponent{
	private readonly meta=inject(Meta);
	private readonly titleService=inject(Title);
	readonly appService=inject(AppService);
	readonly title=$localize`:site title:L&O Medical`;
	readonly pictures:GalleryPicture[]=[
		{src:'images/home1.png',thumb:'images/home1.png',alt:$localize`:gallery alt:L&O medical`},
		{src:'images/home2.png',thumb:'images/home2.png',alt:$localize`:gallery alt:L&O medical`},
		{src:'images/home3.png',thumb:'images/home3.png',alt:$localize`:gallery alt:L&O medical`}
	];

	constructor(){
		const description=$localize`:index description:En L&O Medical, brindamos modernas experiencias de estilo de vida, logrando satisfacer de manera integral las necesidades de salud, belleza y bienestar de nuestros pacientes.`;
		this.titleService.setTitle(this.title);
		this.meta.updateTag({content:this.title},'property="og:title"');
		this.meta.updateTag({content:description},'name="description"');
		this.meta.updateTag({content:description},'property="og:description"');
		this.meta.updateTag({content:$localize`:index keywords:lyo, l&o, medical, medicina, biorreguladora, sueroterapia, autosanguis, bogotá, soacha, ibagué`},'name="keywords"');
		this.meta.updateTag({content:this.appService.ogImageUrl},'property="og:image"');
	}
}
